import { ALL_FILTER_VALUE, type FilterOption } from '@features/regional-overview/regional-overview.models';
import type { TFunction } from 'i18next';

export const getSelectedText = (t: TFunction, isAllChecked: boolean, selectedCount: number) => {
  if (isAllChecked) {
    return t('pages.regional_overview.filters.all_selected');
  }
  if (selectedCount > 0) {
    return `(${selectedCount})`;
  }
  return undefined;
};

export const sortFilterOptionsByLabel = (
  options: FilterOption[],
  getLabel: (option: FilterOption) => string,
  locale: string
): FilterOption[] => {
  const primaryCollator = new Intl.Collator(locale, { numeric: true, sensitivity: 'base' });
  const tieBreakCollator = new Intl.Collator(locale, { numeric: true, sensitivity: 'variant' });
  const allOptions = options.filter(option => option.value === ALL_FILTER_VALUE);
  const sortableOptions = options.filter(option => option.value !== ALL_FILTER_VALUE);
  const labelledOptions = sortableOptions.map(option => ({ option, label: getLabel(option) }));

  labelledOptions.sort((first, second) => {
    return primaryCollator.compare(first.label, second.label) || tieBreakCollator.compare(first.label, second.label);
  });
  return [...allOptions, ...labelledOptions.map(({ option }) => option)];
};
